export const OVERVIEW_DUMMY_DATA = [
  {
    avatarUrl: "/img/widgets/people/person-male-11.png",
    name: "Ethan Thompson",
    subtitle: "DevOps Engineer",
    label: "May 15",
    emoji: "🚀",
  },
  {
    avatarUrl: "/img/widgets/people/person-male-12.png",
    name: "Takeshi Yamamoto",
    subtitle: "QA Lead",
    label: "May 30",
    emoji: "🚀",
  },
];
